// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TextInputPanel_wrap__LvJhs","inputWrap":"TextInputPanel_inputWrap__4ABdv","submit":"TextInputPanel_submit__I1qg4","sendIcon":"TextInputPanel_sendIcon__4xd5k"};